import styled from "styled-components";

import { StyledFileUploaderBox as FileUploaderBox } from "@/components/organisms/Uploader/styled";

export const StyledFileUploaderBox = styled(FileUploaderBox)<{ $withoutPreview: boolean }>`
    flex: 0 0 auto;
    margin-bottom: 3px;
    font-size: var(--size-12);
    border-radius: 8px;

    ${(props) =>
        props.$withoutPreview &&
        `
        align-self: flex-end;
        width: 200px;
        height: 32px;
        background-color: var(--color-grey-900);
        opacity: 0.8;
        .fileUploaderFileImage {
            opacity: 0.2;
        }
        `}

    .image-container {
        text-align: center;
        .fileUploaderFileImage {
            opacity: 1;
        }
    }

    .file-uploader-file {
        flex-direction: row;
        height: 100%;
        padding: 0 8px;
        > .file-name {
            display: -webkit-box;
            display: -moz-box;
            margin-left: 8px;
            overflow: hidden;
            text-overflow: ellipsis;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            -moz-box-orient: vertical;
        }

        > .file-name,
        svg {
            align-self: center;
        }
    }
`;
